import { apiGet, apiPost, apiRequest } from "./client";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const leaksApi = {
  listOwn: () => apiGet("/api/leaks"),
  get: (id) => apiGet(`/api/leaks/${id}`),
  create: (data) => apiPost("/api/leaks", data),
  uploadImage: async (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch(`${API_BASE}/api/leaks/${id}/images`, {
      method: "POST",
      credentials: "include",
      body: fd,
    });
    if (!res.ok) throw new Error(`Upload failed (${res.status})`);
    return res.json();
  },
  imageUrl: (imageId) => `${API_BASE}/api/leaks/images/${imageId}/download`,
};

export const leaksAdminApi = {
  list: () => apiGet("/api/admin/leaks"),
  get: (id) => apiGet(`/api/leaks/${id}`),
  listStudents: () => apiGet("/api/admin/users?role=student"),
  create: (data) => apiPost("/api/admin/leaks", data),
  update: (id, patch) =>
    apiRequest(`/api/admin/leaks/${id}`, { method: "PATCH", body: patch }),
  remove: (id) =>
    apiRequest(`/api/admin/leaks/${id}`, { method: "DELETE" }),
  uploadImage: async (id, file, kind = "initial") => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("kind", kind);
    const res = await fetch(`${API_BASE}/api/admin/leaks/${id}/images`, {
      method: "POST",
      credentials: "include",
      body: fd,
    });
    if (!res.ok) throw new Error(`Upload failed (${res.status})`);
    return res.json();
  },
  removeImage: (id, imageId) =>
    apiRequest(`/api/admin/leaks/${id}/images/${imageId}`, { method: "DELETE" }),
};

export const STATUS_KEYS = {
  received: "leaks.status.received",
  in_progress: "leaks.status.in_progress",
  success: "leaks.status.success",
  failure: "leaks.status.failure",
};

export const STATUS_COLORS = {
  received: "bg-blue-50 text-blue-700",
  in_progress: "bg-amber-50 text-amber-700",
  success: "bg-emerald-50 text-emerald-700",
  failure: "bg-red-50 text-red-700",
};

export const isClosed = (status) => status === "success" || status === "failure";
